// @ts-nocheck

const customInputs = () => {
  var customSelects = document.querySelectorAll(".js-custom-select select");

  if (customSelects.length > 0) {
    customSelects.forEach(function (selElmnt) {
      var parent = selElmnt.parentNode;

      var selectedDiv = document.createElement("DIV");
      selectedDiv.setAttribute("class", "select-selected");
      selectedDiv.innerHTML = "Issue Area";
      parent.appendChild(selectedDiv);

      var optionsDiv = document.createElement("DIV");
      optionsDiv.setAttribute("class", "select-items select-hide");

      for (var j = 0; j < selElmnt.length; j++) {
        var optionDiv = document.createElement("DIV");
        optionDiv.innerHTML = selElmnt.options[j].innerHTML;
        optionDiv.addEventListener("click", function (e) {
          var y, k, s, h, sl, yl;

          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;

          for (k = 0; k < sl; k++) {
            if (s.options[k].innerHTML == this.innerHTML) {
              s.selectedIndex = k;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;

              for (var m = 0; m < yl; m++) {
                y[m].removeAttribute("class");
              }

              this.setAttribute("class", "same-as-selected");
              break;
            }
          }

          h.click();
        });

        optionsDiv.appendChild(optionDiv);
      }

      parent.appendChild(optionsDiv);

      selectedDiv.addEventListener("click", function (e) {
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
    });

    function closeAllSelect(elmnt) {
      var x,
        y,
        k,
        xl,
        yl,
        arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
    }

    document.addEventListener("click", closeAllSelect);
  }

  const checkboxDrop = document.querySelector(".wpcf7-checkbox");
  let dropTitle = document.createElement("DIV");
  dropTitle.setAttribute("class", "check-title");
  dropTitle.innerHTML = "Select all that apply";
  checkboxDrop?.insertBefore(dropTitle, checkboxDrop.firstChild);
  let height =
    dropTitle.getBoundingClientRect().height +
    parseInt(getComputedStyle(checkboxDrop).paddingTop) +
    parseInt(getComputedStyle(checkboxDrop).paddingBottom);
  checkboxDrop.style.maxHeight = height + "px";

  window.addEventListener("resize", () => {
    height =
      dropTitle.getBoundingClientRect().height +
      parseInt(getComputedStyle(checkboxDrop).paddingTop) +
      parseInt(getComputedStyle(checkboxDrop).paddingBottom);
    checkboxDrop.style.maxHeight = height + "px";
  });

  const customCheckboxes = document.querySelectorAll(
    '.js-custom-select input[type="checkbox"]'
  );

  dropTitle.addEventListener("click", () => {
    checkboxDrop?.classList.toggle("active");
  });

  if (customCheckboxes.length > 0) {
    customCheckboxes.forEach((checkbox) => {
      const label = checkbox.nextElementSibling;

      checkbox.addEventListener("change", () => {
        checkbox.checked
          ? label?.classList.add("checked")
          : label?.classList.remove("checked");
      });
    });
  }
};

export default customInputs;
